// extracted by css-extract-rspack-plugin
export default {"changeImageButton":"ImageUploader_changeImageButton__+pugH","inputWrapper":"ImageUploader_inputWrapper__QeaSN"};